var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "forgotPw" }, [
    _c(
      "div",
      {
        staticClass: "forgotPwPanel",
        attrs: {
          title:
            "Note: Recovery emails have a 5 minute cooldown per user account."
        }
      },
      [
        _c("div", { staticClass: "systemName" }, [
          _vm._v(_vm._s(_vm.systemName))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "titleBar" }, [_vm._v("Password Recovery")]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.user,
              expression: "user"
            }
          ],
          staticClass: "txtUser",
          attrs: { type: "text", placeholder: "User Name" },
          domProps: { value: _vm.user },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.InitiateRequest($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.user = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("input", {
          staticClass: "btnRequest",
          attrs: {
            type: "button",
            value: "Send Recovery Email",
            disabled: !_vm.requestEnabled
          },
          on: {
            click: _vm.InitiateRequest,
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar"
                ]) &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.InitiateRequest($event)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "backToLoginLinkWrapper" },
          [
            _c(
              "router-link",
              {
                staticClass: "backToLoginLink",
                attrs: { to: { name: "login" } }
              },
              [_vm._v("Back to Login")]
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _vm.error
      ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hint" }, [
      _vm._v("Enter your "),
      _c("b", [_vm._v("user name")]),
      _vm._v(
        " and we'll send an email with a code you will need to paste on the next page."
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }